export default __webpack_public_path__ + "static/media/her2.d48b0376.png";